/**
 * Created by Mateusz Lipowski on 07.11.2016.
 */

namespace Control.CallbackContainer {
    type EventCallback = (e: CallbackContainer.Event) => boolean;

    export class Callback {
        public constructor(protected _callback: EventCallback, protected _id: number) {

        }

        public get callback(): EventCallback {
            return this._callback;
        }

        public get id(): number {
            return this._id;
        }
    }
}
